import styled from 'styled-components';
import { breakpoints, fonts } from '@vfit/shared/themes';

export const MainContainer = styled.div<{ color?: string }>`
  display: flex;
  height: 64px;
  padding: 16px 16px 12px;
  align-items: center;
  align-self: stretch;
  flex-direction: row;
  justify-content: center;
  font-family: ${fonts.regular};
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;

  span,
  p {
    color: ${({ color }) => color || 'black'};
    margin: 0;
  }

  .logo-text-container {
    display: flex;
    align-items: left;
    flex-direction: column;

    @media (min-width: ${breakpoints.tablet}) {
      flex-direction: row;
    }

    @media (min-width: ${breakpoints.desktop}) {
      font-size: 22px;
      line-height: 32px;
    }
  }

  .top-banner-close {
    display: flex;
    height: 100%;
    align-items: baseline;
    @media (min-width: ${breakpoints.tablet}) {
      align-items: center;
      padding-bottom: 10px;
    }
  }

  @media (min-width: ${breakpoints.tablet}) {
    justify-content: space-between;
    padding: 16px 24px;
  }
  @media (min-width: ${breakpoints.tablet}) {
    justify-content: space-between;
    padding: 16px 80px;
  }
`;

export const LogoContainer = styled.div`
  margin-bottom: 8px;
  height: 32px;
  img {
    object-fit: contain !important;
    width: auto !important;
  }
  @media (min-width: ${breakpoints.tablet}) {
    margin-right: 24px;
    margin-bottom: 0px;
  }
`;

